import { Application } from '@feathersjs/feathers';
import { restClient } from 'ra-data-feathers';

export default function dataProvider(app: Application) {
  return restClient(app, {
    id: '_id', // In this example, the database uses '_id' rather than 'id'
    usePatch: true, // Use PATCH instead of PUT for updates
    customQueryOperators: ['$regex']
  });
}
